import XTbl, {Xtc} from '../../components/new-x-table/index';

const tbl = new XTbl('http://hr.asco-intl.com:2020/kernel/api/user/table', 'لیست کاربران');
tbl.add(new Xtc('id', 'id').filterNumber());
tbl.add(new Xtc('name', 'نام و نام خانوادگی').filterText());
tbl.add(new Xtc('user_type.value', 'نوع کاربر').filterText());
tbl.add(new Xtc('mobile', 'شماره تلفن').filterText());
tbl.add(new Xtc('operator', 'عملیات').renderSlot('operator').noSort());

export default tbl;
